import styled from '@emotion/styled';

export const FooterWrap = styled.div<{ $empty?: boolean }>`
  display: flex;
  flex-direction: ${({ $empty }) => ($empty ? 'column' : 'row')};
  align-items: center;
  justify-content: ${({ $empty }) => ($empty ? 'center' : 'flex-start')};
  gap: ${({ $empty }) => ($empty ? '12px' : '0')};
  align-self: stretch;
  padding: ${({ $empty }) => ($empty ? '24px 0' : '4px 0 0')};
  font-size: 14px;
  line-height: 24px;
`;

export const EmptyText = styled.span`
  color: var(--dk-text-dim, #b7bbc2);
`;
